export enum PrecheckStatus {
  GRANTED = 'GRANTED',
  DENIED = 'DENIED',
  CANCELLED = 'CANCELLED',
  PENDING = 'PENDING',
}
